import React, { useEffect, useState } from 'react';
import useCokitchenContext from 'contexts/cokitchen.context';
import { BrandType } from 'utils/types';
import useDashboardContext from 'contexts/dashboard.context';
import { apiService } from 'services/base.service';
import { getSimpleDateFormat } from 'utils/functions';
import PageText from 'components/base/page-text';

const PreviewBrands = () => {
  const { activeCokitchen, category } = useDashboardContext();
  const { createCokitchenForm } = useCokitchenContext();
  const [loading, setLoading] = useState(false);
  const [brands, setBrands] = useState<BrandType[]>([]);
  const [selectedBrands, setSelectedBrands] = useState<BrandType[]>([]);
  useEffect(() => {
    fetchAllBrands();
  }, [category, activeCokitchen]);

  const fetchAllBrands = async () => {
    if (brands.length > 0) return;
    try {
      setLoading(true);
      const params = {
        item_type: 'FOOD',
        archived: false
      };
      const res = await apiService.get<BrandType[]>('brand_management/brands', {
        params,
        isInternal: true
      });
      const unarchivedBrands = res.data
        .filter(({ archived }) => !archived)
        .sort((a, b) => a.name.localeCompare(b.name));
      setBrands(unarchivedBrands);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (createCokitchenForm.brand_ids.length > 0) {
      setSelectedBrands(brands.filter((brand) => createCokitchenForm.brand_ids.includes(brand.id)));
    }
  }, [brands]);
  return (
    <div>
      {loading ? (
        <PageText text='Loading...' />
      ) : selectedBrands.length === 0 ? (
        <PageText text='No brands found' />
      ) : (
        <div className='grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5'>
          {selectedBrands.map((brand) => (
            <div
              key={brand.id}
              className={`  flex flex-col relative hover:bg-[#F7F7F8] border border-1 z-0 rounded-[10px] border-[#EDEDEE] px-[24px] py-[20px] transition-height duration-1000 `}>
              <img
                className='w-16 h-16 rounded-full border border-[#E9ECEC] object-cover'
                src={brand.logo}
              />
              <p className='text-lg font-medium pt-2 pb-1'>{brand.name}</p>
              <p className='grow text-[#858585] text-xs leading-5'> {brand.description}</p>
              <hr className='my-3 text-[#DDDEDF]' />
              <p className='text-[10px] text-[#858585] pb-6'>
                Added {getSimpleDateFormat(brand.updated_at ?? '')}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PreviewBrands;
